import { motion } from 'framer-motion';
import { Compass, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 text-center">
      <motion.div
        animate={{ rotate: [0, 20, -15, 0] }}
        transition={{ repeat: Infinity, duration: 4, ease: 'easeInOut' }}
        className="flex size-20 items-center justify-center rounded-3xl bg-brand-gradient text-primary-foreground shadow-glow"
      >
        <Compass className="size-10" />
      </motion.div>
      <div>
        <p className="text-6xl font-black tracking-tight text-gradient">404</p>
        <p className="mt-2 text-muted-foreground">This page took a wrong turn.</p>
      </div>
      <Button asChild variant="brand">
        <Link to="/">
          <Home /> Back to dashboard
        </Link>
      </Button>
    </div>
  );
}
